(function (global) {
  'use strict';
  function createCommerce({ fetch: request, config, onChange = () => {} }) {
    let cart = config.cart, pending = 0, uncertain = false, tail = Promise.resolve();
    const notify = () => onChange({ cart, pending, uncertain });
    const quantity = (value, min) => {
      const number = Number(value);
      if (!Number.isInteger(number) || number < min || number > 99) throw new Error('Choose a quantity from ' + min + ' to 99.');
      return number;
    };
    async function json(url, body) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await request(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}), signal: controller.signal });
        let result;
        try { result = await response.json(); } catch (_) { throw new Error('We could not confirm your cart. Please refresh it before trying again.'); }
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : 'Your cart could not be updated. Please check availability.');
        return result;
      } finally { clearTimeout(timer); }
    }
    async function read() {
      const result = await json(config.cartUrl + '.js');
      if (!Array.isArray(result.items) || !Number.isFinite(result.total_price)) throw new Error('We could not confirm your cart. Please refresh it.');
      cart = result; uncertain = false; notify(); return cart;
    }
    function queue(task) {
      pending++; notify();
      const next = tail.then(task);
      tail = next.catch(() => {});
      return next.finally(() => { pending--; notify(); });
    }
    async function mutate(url, body, returnsCart) {
      if (uncertain) throw new Error('Refresh your cart before changing it again.');
      try {
        const result = await json(url, body);
        if (returnsCart) {
          if (!Array.isArray(result.items) || !Number.isFinite(result.total_price)) throw new Error('We could not confirm your cart.');
          cart = result; notify(); return cart;
        }
        return await read();
      } catch (error) {
        uncertain = true;
        try { await read(); } catch (_) { notify(); }
        throw error;
      }
    }
    return {
      getState: () => ({ cart, pending, uncertain }),
      canCheckout: () => pending === 0 && !uncertain,
      idle: () => tail,
      refresh: () => queue(async () => { try { return await read(); } catch (error) { uncertain = true; notify(); throw error; } }),
      add: (id, qty = 1, extra = {}) => queue(() => {
        if (!/^[1-9]\d*$/.test(String(id))) throw new Error('Choose an available product option.');
        const item = { id: String(id), quantity: quantity(qty, 1) };
        if (extra.selling_plan) item.selling_plan = String(extra.selling_plan);
        if (extra.properties) item.properties = extra.properties;
        return mutate(config.addUrl, { items: [item] }, false);
      }),
      change: (key, qty) => queue(() => {
        if (!cart.items.some(item => item.key === key)) throw new Error('This cart item changed. Please refresh your cart.');
        return mutate(config.changeUrl, { id: key, quantity: quantity(qty, 0) }, true);
      }),
      adjust: (key, delta) => queue(() => {
        const item = cart.items.find(line => line.key === key);
        if (!item) throw new Error('This cart item changed. Please refresh your cart.');
        return mutate(config.changeUrl, { id: key, quantity: quantity(item.quantity + Number(delta), 0) }, true);
      })
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createCommerce };
  else global.BiohackrCommerce = { createCommerce };
})(typeof window === 'undefined' ? globalThis : window);
